<svg
  width="90%"
  height="647"
  viewBox="0 0 1902 647"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M642.801 462.867H670.693V519.349C670.693 527.051 664.449 533.295 656.747 533.295C649.045 533.295 642.801 527.051 642.801 519.349V462.867Z"
    fill="#201857"
  />
  <path
    d="M694.4 462.867H722.293V519.349C722.293 527.051 716.049 533.295 708.346 533.295C700.644 533.295 694.4 527.051 694.4 519.349V462.867Z"
    fill="#201857"
  />
  <path
    d="M1078.62 467.051H1106.51V519.349C1106.51 527.051 1100.26 533.295 1092.56 533.295C1084.86 533.295 1078.62 527.051 1078.62 519.349V467.051Z"
    fill="#201857"
  />
  <path
    d="M1130.22 467.051H1158.11V519.349C1158.11 527.051 1151.87 533.295 1144.16 533.295C1136.46 533.295 1130.22 527.051 1130.22 519.349V467.051Z"
    fill="#201857"
  />
  <g filter="url(#filter0_di_932_6)">
    <rect
      x="619.5"
      y="52.5"
      width="569"
      height="412"
      rx="22.5"
      stroke="white"
      stroke-width="5"
      shape-rendering="crispEdges"
    />
  </g>
  <g filter="url(#filter1_di_932_6)">
    <rect
      x="628"
      y="62"
      width="553"
      height="392"
      rx="25"
      fill="#FF509F"
      fill-opacity="0.1"
      shape-rendering="crispEdges"
    />
    <rect
      x="630.5"
      y="64.5"
      width="548"
      height="387"
      rx="22.5"
      stroke="white"
      stroke-width="5"
      shape-rendering="crispEdges"
    />
  </g>
  <path d="M896.711 504.914H894.432V520.244H896.711V504.914Z" fill="#185E45" />
  <path
    d="M895.572 507.371C899.615 507.371 902.893 504.121 902.893 500.112C902.893 496.103 899.615 492.854 895.572 492.854C891.528 492.854 888.25 496.103 888.25 500.112C888.25 504.121 891.528 507.371 895.572 507.371Z"
    fill="#FEBC87"
  />
  <path
    d="M895.578 504.914C898.306 504.914 900.519 502.721 900.519 500.016C900.519 497.31 898.306 495.117 895.578 495.117C892.849 495.117 890.637 497.31 890.637 500.016C890.637 502.721 892.849 504.914 895.578 504.914Z"
    fill="#FFDFAD"
  />
  <g clip-path="url(#clip0_932_6)">
    <path
      d="M805.449 523.501L804.625 526.705L803.8 523.501C801.081 512.945 801.401 499.923 804.623 490.062C807.845 499.923 808.165 512.945 805.448 523.501H805.449Z"
      fill="#185E45"
    />
    <path
      d="M804.164 522.403L804.623 525.94L802.998 524.943C797.648 521.662 793.644 511.961 792.719 500.029C798.2 502.043 802.657 510.758 804.164 522.403Z"
      fill="#185E45"
    />
    <path
      d="M806.245 525.019L804.623 526.046L805.067 522.5C806.53 510.828 810.955 502.034 816.428 499.92C815.548 511.868 811.581 521.639 806.243 525.019H806.245Z"
      fill="#185E45"
    />
  </g>
  <g clip-path="url(#clip1_932_6)">
    <path
      d="M988.144 523.501L987.32 526.705L986.495 523.501C983.776 512.945 984.097 499.923 987.318 490.062C990.54 499.923 990.861 512.945 988.143 523.501H988.144Z"
      fill="#185E45"
    />
    <path
      d="M986.86 522.403L987.318 525.94L985.693 524.943C980.343 521.662 976.339 511.961 975.414 500.029C980.896 502.043 985.353 510.758 986.86 522.403Z"
      fill="#185E45"
    />
    <path
      d="M988.94 525.019L987.318 526.046L987.763 522.5C989.225 510.828 993.65 502.034 999.123 499.92C998.243 511.868 994.277 521.639 988.938 525.019H988.94Z"
      fill="#185E45"
    />
  </g>
  <circle
    cx="7.72435"
    cy="7.72435"
    r="7.72435"
    transform="matrix(-1 0 0 1 859.672 495.639)"
    fill="#185E45"
  />
  <circle
    cx="7.72435"
    cy="7.72435"
    r="7.72435"
    transform="matrix(-1 0 0 1 855.586 501.002)"
    fill="#185E45"
  />
  <ellipse
    cx="7.14981"
    cy="7.21365"
    rx="7.14981"
    ry="7.21365"
    transform="matrix(-1 0 0 1 864.014 498.32)"
    fill="#185E45"
  />
  <rect
    width="3.82427"
    height="14.555"
    rx="1.91214"
    transform="matrix(-1 0 0 1 855.586 516.449)"
    fill="#185E45"
  />
  <circle
    cx="7.72435"
    cy="7.72435"
    r="7.72435"
    transform="matrix(-1 0 0 1 855.586 510.574)"
    fill="#185E45"
  />
  <ellipse
    cx="7.72435"
    cy="7.66051"
    rx="7.72435"
    ry="7.66051"
    transform="matrix(-1 0 0 1 867.332 507.002)"
    fill="#185E45"
  />
  <ellipse
    cx="7.72435"
    cy="7.66051"
    rx="7.72435"
    ry="7.66051"
    transform="matrix(-1 0 0 1 867.332 507.002)"
    fill="#185E45"
  />
  <ellipse cx="939.894" cy="501.275" rx="7.72424" ry="7.72435" fill="#185E45" />
  <ellipse cx="943.98" cy="506.638" rx="7.72424" ry="7.72435" fill="#185E45" />
  <ellipse cx="934.978" cy="503.446" rx="7.14971" ry="7.21365" fill="#185E45" />
  <rect
    x="936.256"
    y="514.361"
    width="3.82422"
    height="14.555"
    rx="1.91211"
    fill="#185E45"
  />
  <ellipse cx="943.98" cy="516.211" rx="7.72424" ry="7.72435" fill="#185E45" />
  <ellipse cx="932.234" cy="512.575" rx="7.72424" ry="7.66051" fill="#185E45" />
  <ellipse cx="932.234" cy="512.575" rx="7.72424" ry="7.66051" fill="#185E45" />
  <path
    d="M897.067 533.269H764.46C759.652 533.269 755.762 529.373 755.762 524.571V522.831C755.762 520.909 757.319 519.352 759.241 519.352H902.293C904.215 519.352 905.772 520.909 905.772 522.831V524.571C905.772 529.379 901.876 533.269 897.074 533.269H897.067Z"
    fill="#10293A"
  />
  <path
    d="M1032.34 533.269H899.738C894.929 533.269 891.039 529.373 891.039 524.571V522.831C891.039 520.909 892.596 519.352 894.518 519.352H1037.57C1039.49 519.352 1041.05 520.909 1041.05 522.831V524.571C1041.05 529.379 1037.15 533.269 1032.35 533.269H1032.34Z"
    fill="#10293A"
  />
  <path
    d="M541.495 393.262C541.022 392.989 540.477 392.899 539.883 392.953C539.143 389.734 537.525 387.491 535.639 387.491C534.924 387.491 534.245 387.825 533.639 388.401C532.784 386.321 531.487 385 530.032 385C528.577 385 527.286 386.321 526.426 388.401C525.819 387.825 525.14 387.491 524.425 387.491C522.57 387.491 520.97 389.662 520.218 392.802C519.588 392.729 519.006 392.814 518.509 393.099C516.272 394.39 516.557 399.057 519.133 403.525C521.285 407.247 524.346 409.647 526.601 409.605V409.914H534.076V409.72C536.24 409.338 538.925 407.047 540.865 403.689C543.447 399.221 543.726 394.553 541.489 393.262H541.495Z"
    fill="#185E45"
  />
  <path
    d="M492.495 393.291C492.022 393.017 491.477 392.926 490.883 392.981C490.143 389.751 488.525 387.5 486.64 387.5C485.924 387.5 485.245 387.835 484.639 388.412C483.784 386.326 482.487 385 481.032 385C479.577 385 478.286 386.326 477.426 388.412C476.819 387.835 476.14 387.5 475.425 387.5C473.57 387.5 471.97 389.678 471.218 392.828C470.588 392.755 470.006 392.841 469.509 393.127C467.272 394.422 467.557 399.106 470.133 403.589C472.285 407.324 475.346 409.732 477.601 409.69V410H485.076V409.805C487.24 409.422 489.925 407.123 491.865 403.753C494.447 399.27 494.726 394.586 492.489 393.291H492.495Z"
    fill="#185E45"
  />
  <path
    d="M443.495 393.622C443.022 393.338 442.477 393.243 441.883 393.3C441.143 389.941 439.525 387.6 437.639 387.6C436.924 387.6 436.245 387.948 435.639 388.549C434.784 386.379 433.487 385 432.032 385C430.577 385 429.286 386.379 428.426 388.549C427.819 387.948 427.14 387.6 426.425 387.6C424.57 387.6 422.97 389.865 422.218 393.142C421.588 393.066 421.006 393.154 420.509 393.452C418.272 394.799 418.557 399.67 421.133 404.332C423.285 408.217 426.346 410.722 428.601 410.677V411H436.076V410.798C438.24 410.399 440.925 408.008 442.865 404.503C445.447 399.841 445.726 394.97 443.489 393.622H443.495Z"
    fill="#185E45"
  />
  <path
    d="M543.702 418H417.292C412.708 418 409 414.36 409 409.875V408.25C409 406.455 410.484 405 412.317 405H548.683C550.516 405 552 406.455 552 408.25V409.875C552 414.367 548.286 418 543.708 418H543.702Z"
    fill="#10293A"
  />
  <path
    d="M334.989 352H331.011C326.587 352 323 355.707 323 360.28V423.72C323 428.293 326.587 432 331.011 432H334.989C339.413 432 343 428.293 343 423.72V360.28C343 355.707 339.413 352 334.989 352Z"
    fill="#1D1743"
  />
  <path
    d="M93.9892 358H90.0108C85.5866 358 82 361.661 82 366.177V428.823C82 433.339 85.5866 437 90.0108 437H93.9892C98.4134 437 102 433.339 102 428.823V366.177C102 361.661 98.4134 358 93.9892 358Z"
    fill="#1D1743"
  />
  <path
    d="M466.156 183.672L99.8441 184C91.6462 184 85 180.296 85 175.732V8.59616C85 4.02558 91.6462 0.328239 99.8441 0.328239L466.156 0C474.354 0 481 3.70353 481 8.26792V175.404C481 179.974 474.354 183.672 466.156 183.672Z"
    fill="#362C7B"
  />
  <path
    d="M371.558 209H10.4416C4.67488 209 0 213.697 0 219.491V382.509C0 388.303 4.67488 393 10.4416 393H371.558C377.325 393 382 388.303 382 382.509V219.491C382 213.697 377.325 209 371.558 209Z"
    fill="#362C7B"
  />
  <path
    d="M548.112 599.674L81.8885 600C71.4552 600 63 596.317 63 591.777V425.549C63 421.004 71.4552 417.326 81.8885 417.326L548.112 417C558.545 417 567 420.683 567 425.223V591.451C567 595.996 558.545 599.674 548.112 599.674Z"
    fill="#362C7B"
  />
  <path
    d="M1531.39 316H1527.61C1523.41 316 1520 322.071 1520 329.559V433.441C1520 440.929 1523.41 447 1527.61 447H1531.39C1535.59 447 1539 440.929 1539 433.441V329.559C1539 322.071 1535.59 316 1531.39 316Z"
    fill="#1D1743"
  />
  <path
    d="M1419.39 312H1415.61C1411.41 312 1408 318.071 1408 325.559V429.441C1408 436.929 1411.41 443 1415.61 443H1419.39C1423.59 443 1427 436.929 1427 429.441V325.559C1427 318.071 1423.59 312 1419.39 312Z"
    fill="#1D1743"
  />
  <path
    d="M1562.46 157H1244.83C1239.76 157 1235.64 161.671 1235.64 167.434V329.566C1235.64 335.329 1239.76 340 1244.83 340H1562.46C1567.53 340 1571.64 335.329 1571.64 329.566V167.434C1571.64 161.671 1567.53 157 1562.46 157Z"
    fill="#362C7B"
  />
  <path
    d="M1641.81 360H1645.19C1648.95 360 1652 363.707 1652 368.28V431.72C1652 436.293 1648.95 440 1645.19 440H1641.81C1638.05 440 1635 436.293 1635 431.72V368.28C1635 363.707 1638.05 360 1641.81 360Z"
    fill="#1D1743"
  />
  <path
    d="M1803.81 362H1807.19C1810.95 362 1814 365.707 1814 370.28V433.72C1814 438.293 1810.95 442 1807.19 442H1803.81C1800.05 442 1797 438.293 1797 433.72V370.28C1797 365.707 1800.05 362 1803.81 362Z"
    fill="#1D1743"
  />
  <path
    d="M1608.25 217H1893.75C1898.3 217 1902 221.671 1902 227.434V389.566C1902 395.329 1898.3 400 1893.75 400H1608.25C1603.7 400 1600 395.329 1600 389.566V227.434C1600 221.671 1603.7 217 1608.25 217Z"
    fill="#362C7B"
  />
  <path
    d="M140 549.34V603H89V549.34C89 544.729 92.7316 541 97.3305 541H131.663C136.268 541 139.994 544.736 139.994 549.34H140Z"
    fill="#FCB972"
  />
  <path
    d="M1360.04 609.674L1827.19 610C1837.64 610 1846.11 606.317 1846.11 601.777V435.549C1846.11 431.004 1837.64 427.326 1827.19 427.326L1360.04 427C1349.58 427 1341.11 430.683 1341.11 435.223V601.451C1341.11 605.996 1349.58 609.674 1360.04 609.674Z"
    fill="#362C7B"
  />
  <g filter="url(#filter2_di_932_6)">
    <path
      d="M1750.11 570.591V613H1799.11V570.591C1799.11 566.947 1795.53 564 1791.11 564H1758.12C1753.7 564 1750.12 566.952 1750.12 570.591H1750.11Z"
      fill="#BA74FF"
    />
  </g>
  <g filter="url(#filter3_di_932_6)">
    <rect x="1735.11" y="516" width="79" height="28" rx="8" fill="#BA74FF" />
  </g>
  <g filter="url(#filter4_di_932_6)">
    <rect x="1735.11" y="469" width="79" height="28" rx="8" fill="#BA74FF" />
  </g>
  <path
    d="M1404.85 398.561C1404.58 398.534 1404.3 398.561 1404.03 398.632C1404.05 398.212 1404.08 397.786 1404.08 397.349C1404.08 392.218 1402.03 388.053 1399.5 388.053C1398.68 388.053 1397.92 388.496 1397.26 389.26C1396.8 385.106 1394.98 382 1392.8 382C1390.78 382 1389.08 384.653 1388.47 388.326C1387.93 387.862 1387.32 387.606 1386.7 387.606C1384.18 387.606 1382.13 391.765 1382.13 396.902C1382.13 397.415 1382.16 397.917 1382.2 398.408C1381.71 398.201 1381.23 398.119 1380.76 398.179C1378.28 398.512 1377.28 402.879 1378.55 407.928C1379.81 412.977 1382.85 416.803 1385.33 416.465C1385.61 416.427 1385.88 416.329 1386.12 416.192V416.967H1400.14V416.378C1400.54 416.722 1400.98 416.94 1401.48 416.989C1403.98 417.235 1406.76 413.31 1407.69 408.223C1408.63 403.135 1407.35 398.812 1404.85 398.567V398.561Z"
    fill="#185E45"
  />
  <path
    d="M1502.95 398.561C1502.69 398.534 1502.42 398.561 1502.16 398.632C1502.19 398.212 1502.21 397.786 1502.21 397.349C1502.21 392.218 1500.22 388.053 1497.78 388.053C1496.99 388.053 1496.25 388.496 1495.61 389.26C1495.17 385.106 1493.41 382 1491.3 382C1489.36 382 1487.71 384.653 1487.12 388.326C1486.6 387.862 1486.01 387.606 1485.41 387.606C1482.97 387.606 1480.99 391.765 1480.99 396.902C1480.99 397.415 1481.02 397.917 1481.06 398.408C1480.59 398.201 1480.12 398.119 1479.67 398.179C1477.27 398.512 1476.31 402.879 1477.53 407.928C1478.75 412.977 1481.68 416.803 1484.08 416.465C1484.36 416.427 1484.61 416.329 1484.85 416.192V416.967H1498.41V416.378C1498.79 416.722 1499.22 416.94 1499.69 416.989C1502.11 417.235 1504.8 413.31 1505.7 408.223C1506.61 403.135 1505.37 398.812 1502.95 398.567V398.561Z"
    fill="#185E45"
  />
  <path
    d="M1453.95 398.561C1453.69 398.534 1453.42 398.561 1453.16 398.632C1453.19 398.212 1453.21 397.786 1453.21 397.349C1453.21 392.218 1451.22 388.053 1448.78 388.053C1447.99 388.053 1447.25 388.496 1446.61 389.26C1446.17 385.106 1444.41 382 1442.3 382C1440.36 382 1438.71 384.653 1438.12 388.326C1437.6 387.862 1437.01 387.606 1436.41 387.606C1433.97 387.606 1431.99 391.765 1431.99 396.902C1431.99 397.415 1432.02 397.917 1432.06 398.408C1431.59 398.201 1431.12 398.119 1430.67 398.179C1428.27 398.512 1427.31 402.879 1428.53 407.928C1429.75 412.977 1432.68 416.803 1435.08 416.465C1435.36 416.427 1435.61 416.329 1435.85 416.192V416.967H1449.41V416.378C1449.79 416.722 1450.22 416.94 1450.69 416.989C1453.11 417.235 1455.8 413.31 1456.7 408.223C1457.61 403.135 1456.37 398.812 1453.95 398.567V398.561Z"
    fill="#185E45"
  />
  <path
    d="M1552.85 398.561C1552.58 398.534 1552.3 398.561 1552.03 398.632C1552.05 398.212 1552.08 397.786 1552.08 397.349C1552.08 392.218 1550.03 388.053 1547.5 388.053C1546.68 388.053 1545.92 388.496 1545.26 389.26C1544.8 385.106 1542.98 382 1540.8 382C1538.78 382 1537.08 384.653 1536.47 388.326C1535.93 387.862 1535.32 387.606 1534.7 387.606C1532.18 387.606 1530.13 391.765 1530.13 396.902C1530.13 397.415 1530.16 397.917 1530.2 398.408C1529.71 398.201 1529.23 398.119 1528.76 398.179C1526.28 398.512 1525.28 402.879 1526.55 407.928C1527.81 412.977 1530.85 416.803 1533.33 416.465C1533.61 416.427 1533.88 416.329 1534.12 416.192V416.967H1548.14V416.378C1548.54 416.722 1548.98 416.94 1549.48 416.989C1551.98 417.235 1554.76 413.31 1555.69 408.223C1556.63 403.135 1555.35 398.812 1552.85 398.567V398.561Z"
    fill="#185E45"
  />
  <path
    d="M1561.7 427H1435.29C1430.71 427 1427 423.36 1427 418.875V417.25C1427 415.455 1428.48 414 1430.32 414H1566.68C1568.52 414 1570 415.455 1570 417.25V418.875C1570 423.367 1566.29 427 1561.71 427H1561.7Z"
    fill="#10293A"
  />
  <path
    d="M1497.7 427H1371.29C1366.71 427 1363 423.36 1363 418.875V417.25C1363 415.455 1364.48 414 1366.32 414H1502.68C1504.52 414 1506 415.455 1506 417.25V418.875C1506 423.367 1502.29 427 1497.71 427H1497.7Z"
    fill="#10293A"
  />
  <defs>
    <filter
      id="filter0_di_932_6"
      x="577"
      y="10"
      width="654"
      height="497"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="20" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 1 0 0 0 0 0.227451 0 0 0 0 0.321569 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_932_6"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_932_6"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="2.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 1 0 0 0 0 0.227451 0 0 0 0 0.321569 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_932_6" />
    </filter>
    <filter
      id="filter1_di_932_6"
      x="588"
      y="22"
      width="633"
      height="472"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="20" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.996078 0 0 0 0 0.796078 0 0 0 0 0.0941176 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_932_6"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_932_6"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="7.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.996078 0 0 0 0 0.796078 0 0 0 0 0.0941176 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_932_6" />
    </filter>
    <filter
      id="filter2_di_932_6"
      x="1716.11"
      y="530"
      width="117"
      height="117"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_932_6"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_932_6"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_932_6" />
    </filter>
    <filter
      id="filter3_di_932_6"
      x="1701.11"
      y="482"
      width="147"
      height="96"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_932_6"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_932_6"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_932_6" />
    </filter>
    <filter
      id="filter4_di_932_6"
      x="1701.11"
      y="435"
      width="147"
      height="96"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_932_6"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_932_6"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_932_6" />
    </filter>
    <clipPath id="clip0_932_6">
      <rect
        width="23.7084"
        height="36.6421"
        fill="white"
        transform="translate(792.719 490.062)"
      />
    </clipPath>
    <clipPath id="clip1_932_6">
      <rect
        width="23.7084"
        height="36.6421"
        fill="white"
        transform="translate(975.414 490.062)"
      />
    </clipPath>
  </defs>
</svg>
